module.exports = __webpack_public_path__ + "static/img/30010 (3).98449db.webp";


//////////////////
// WEBPACK FOOTER
// ./src/assets/30000/30010 (3).webp
// module id = nvXP
// module chunks = 14